import { useEffect } from 'react';
import { useConfig } from '../contexts/ConfigContext';

export const useDynamicBranding = () => {
  const { getBrandingConfig, brandingReady } = useConfig();
  const branding = getBrandingConfig();

  useEffect(() => {
    if (!brandingReady) return;

    // Update document title
    if (branding.companyName) {
      document.title = branding.companyName;
    }

    // Update meta description with tagline
    if (branding.tagline) {
      let metaDescription = document.querySelector('meta[name="description"]');
      if (!metaDescription) {
        metaDescription = document.createElement('meta');
        metaDescription.name = 'description';
        document.head.appendChild(metaDescription);
      }
      metaDescription.content = branding.tagline;
    }

    // Update theme color based on primary color
    if (branding.primaryColor) {
      let themeColorMeta = document.querySelector('meta[name="theme-color"]');
      if (!themeColorMeta) {
        themeColorMeta = document.createElement('meta');
        themeColorMeta.name = 'theme-color';
        document.head.appendChild(themeColorMeta);
      }
      themeColorMeta.content = branding.primaryColor;
    }

  }, [branding, brandingReady]);
};

export default useDynamicBranding; 